import React, { useContext } from "react";
import { BuildingContext } from "Context/BuildingProvider";
import ConfigForm, {
  ConfigInput,
  FormOption,
} from "components/Layout/ConfigForm";
import { GET_ROLES } from "lib/roles";
import { GetRolesQueryResult, Role } from "generated/graphql";
import { useQuery } from "@apollo/client";
import { LinearProgress } from "@material-ui/core";

interface TaskRoleChecklistsProps {
  handleTaskStartClick: (id: string | number) => void;
  handleTaskSendClick: (id: string | number) => void;
  selectedRoleTaskStarts: number[];
  selectedRoleTaskSends: number[];
}
export default function TaskRoleChecklists(props: TaskRoleChecklistsProps) {
  const { currentBuilding } = useContext(BuildingContext);
  const { loading, error, data }: GetRolesQueryResult = useQuery(GET_ROLES, {
    variables: {
      buildingId: currentBuilding?.Id,
      limit: 50,
      offset: 0,
    },
  });
  if (loading) {
    return <LinearProgress />;
  } else if (error) {
    return <div>{error.message}</div>;
  } else {
    const roleOptions: FormOption[] = data?.Role
      ? data?.Role.map((role) => {
          return {
            label: role!.Title as string,
            value: role!.Id,
          };
        })
      : [];

    const inputs: ConfigInput[] = [
      {
        title: "Roles Where The User Can Start The Task",
        type: "checklist",
        onChange: () => {},
        onOptionClick: props.handleTaskStartClick,
        selectedOptions: props.selectedRoleTaskStarts,
        xs: 12,
        sm: 6,
        id: "roleTaskStarts",
        options: roleOptions,
      },
      {
        title: "Roles Where The User Can Send The Task",
        type: "checklist",
        onChange: () => {},
        onOptionClick: props.handleTaskSendClick,
        selectedOptions: props.selectedRoleTaskSends,
        xs: 12,
        sm: 6,
        id: "roleTaskSends",
        options: roleOptions,
      },
    ];
    return <ConfigForm inputs={inputs}></ConfigForm>;
  }
}
